import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { ContentGrid, Text, Box, Flex, theme } from "@betterment/style-closet-react";
import styled from "@emotion/styled";
import { width } from "styled-system";
import { u as useFooter } from "./FooterProvider-CjpEJF0L.js";
import { T as TrackableLink, g as brochureUrl, L as Link } from "./index-C6Cle9A9.js";
import { S as SUPPORT_EMAIL } from "./constants-DwFZ-MA6.js";
const FooterBase = styled.div`
  color: ${theme.colors.bmtGrey50};
  font-size: ${theme.fontSizes[1]};
`;
const ContentGridItem = styled(ContentGrid.Item)`
  ${width}
`;
const FooterLink = styled(Link)`
  text-decoration: underline;
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.lineHeights[1]};
  color: ${theme.colors.bmtGrey50} !important;
`;
const FooterText = styled(Text)`
  color: ${theme.colors.bmtGrey50};
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.lineHeights[1]};
  & > a {
    text-decoration: underline;
    font-size: ${theme.fontSizes[1]};
    line-height: ${theme.lineHeights[1]};
    color: ${theme.colors.bmtGrey50} !important;
  }
`;
const Footer = ({
  showCashReserveDisclosure = false,
  showFdicDisclosure = false,
  showCheckingDisclosure = false
}) => {
  const { data } = useFooter();
  return /* @__PURE__ */ jsxs(FooterBase, { children: [
    /* @__PURE__ */ jsxs(ContentGrid, { mb: [8, 8, 9], children: [
      /* @__PURE__ */ jsx(ContentGridItem, { children: /* @__PURE__ */ jsx(Text, { fontWeight: "bold", color: "bmtGrey50", children: "Questions?" }) }),
      /* @__PURE__ */ jsx(ContentGridItem, { children: /* @__PURE__ */ jsx(
        TrackableLink,
        {
          target: "_blank",
          href: brochureUrl("/help"),
          eventProperties: { name: "FAQ" },
          component: FooterLink,
          children: "Support Center"
        }
      ) }),
      /* @__PURE__ */ jsx(ContentGridItem, { children: /* @__PURE__ */ jsx(
        TrackableLink,
        {
          target: "_blank",
          href: brochureUrl("/contact"),
          eventProperties: { name: "ContactUs" },
          component: FooterLink,
          children: "Contact Us"
        }
      ) }),
      /* @__PURE__ */ jsx(ContentGridItem, { children: /* @__PURE__ */ jsx(FooterLink, { href: `mailto:${SUPPORT_EMAIL}`, children: "Email Us" }) })
    ] }),
    data && /* @__PURE__ */ jsxs(Fragment, { children: [
      (showCashReserveDisclosure || showFdicDisclosure) && /* @__PURE__ */ jsxs(Box, { mb: "8", children: [
        /* @__PURE__ */ jsx(FooterText, { as: "h3", children: "Betterment Cash Reserve" }),
        showCashReserveDisclosure && /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.apyDailyRateDisclosure } }),
        showFdicDisclosure && /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.fdicDisclosure } })
      ] }),
      showCheckingDisclosure && /* @__PURE__ */ jsxs(Box, { mb: "10", pb: "10", borderBottom: "1px solid", borderColor: "bmtGrey30", children: [
        /* @__PURE__ */ jsx(FooterText, { as: "h3", children: "Betterment Checking" }),
        /* @__PURE__ */ jsx(Flex, { mb: "4", children: /* @__PURE__ */ jsx(
          FooterText,
          {
            as: "p",
            dangerouslySetInnerHTML: {
              __html: `&Dagger; ${data.terms.checkingDisclosure}`
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs(Flex, { flexDirection: ["column", null, "row"], children: [
        /* @__PURE__ */ jsxs(Flex.Item, { pr: "3", flex: "1", mb: "8", children: [
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.advertisingDisclosure } }),
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.termsAndConditionsLink } }),
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.privatePolicyLink } }),
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.trademarksLink } })
        ] }),
        /* @__PURE__ */ jsxs(Flex.Item, { flex: "3", children: [
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.investmentAdvisorDisclosure } }),
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.brokerageServicesDisclosure } }),
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.everydayCheckingDisclosure } }),
          /* @__PURE__ */ jsx(FooterText, { as: "p", dangerouslySetInnerHTML: { __html: data.terms.investmentInSecuritiesDisclosure } })
        ] })
      ] })
    ] })
  ] });
};
export {
  Footer as F,
  FooterText as a
};
//# sourceMappingURL=Footer-Cjrv9Xj0.js.map
